import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  selectedPortfolioIdLocalSignal = signal(localStorage.getItem('panorama_selected_portfolio_id') || '');

  getLang(): string | null {
    return localStorage.getItem('panorama_lang');
  }

  setLang(lang: string) {
    localStorage.setItem('panorama_lang', lang);
  }

  getThemeName(name: string): string | null {
    return localStorage.getItem(name);
  }

  getSelectedPortfolioId(): string {
    return localStorage.getItem('panorama_selected_portfolio_id') || '';
  }

  setSelectedPortfolioId(selectedPortfolioId: string) {
    localStorage.setItem('panorama_selected_portfolio_id', selectedPortfolioId);
    this.selectedPortfolioIdLocalSignal.set(localStorage.getItem('panorama_selected_portfolio_id') || '');
  }
}
